import React, { useCallback, useState } from 'react'
import { Alert } from 'components'
import { alerts as alertKeys } from 'keys'
import { AutoComplete, Input } from 'components/Form'
import { SmallSpace } from 'styles/GlobalStyle'
import { useAlert } from 'components/Alerts/hooks'
import { useSelector } from 'react-redux'
import { createClassHooks } from '../CreateClass'
import { useQueryClient } from '@tanstack/react-query'
import qc from 'keys/queryClient'
import { semesterAndYearOptions } from 'keys/years'
import { getCurrentSchoolYear } from 'utils/general'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { isEmpty } from 'lodash'

const AddSchoolClass = () => {
    const { setAlerts } = useAlert()
    const { alerts } = useSelector(state => state.general)
    const { grades } = useSelector(state => state.testTaker)

    const currentSchoolYear = getCurrentSchoolYear()

    const [grade, setGrade] = useState(null)
    const [tClass, setTClass] = useState(null)
    const [schoolYear, setSchoolYear] = useState(currentSchoolYear)

    const addSchoolClassAlert = alerts[alertKeys.addSchoolClass]

    const queryClient = useQueryClient()

    const createClass = createClassHooks.useCreateClass()

    const handleAlert = useCallback((val) => {
        setAlerts(alertKeys.addSchoolClass, val)
    }, [])

    const addSchoolClass = useCallback(async () => {
        if (!schoolYear) {
            toast.error("חובה לבחור שנת לימודים", toastConfig)
            return
        }

        const { affiliation } = addSchoolClassAlert?.props
        handleAlert(false)
        await createClass({
            name: tClass,
            affiliation: affiliation,
            grade: grade,
            school_year: schoolYear?.id || schoolYear
        })
        queryClient.invalidateQueries({ queryKey: [qc.affiliationGrades, affiliation] })
    }, [tClass, grade, schoolYear, addSchoolClassAlert])

    const footerActions = React.useMemo(
        () => [
            { label: "שמירה", variant: "regular", color: "thirdly", action: addSchoolClass },
            { label: "ביטול", variant: "white", color: "thirdly4", action: () => handleAlert(false) }
        ], [tClass, grade, schoolYear, addSchoolClassAlert]
    )

    return (
        <Alert
            systemUI
            title={"הוספת שכבה וכיתה"}
            footerActions={footerActions}
            handleAlert={handleAlert}
        >
            <AutoComplete
                placeholder="בחר שכבה"
                input={{
                    value: grade,
                    onChange: setGrade
                }}
                options={grades}
            />
            <SmallSpace />
            <Input
                input={{
                    value: tClass,
                    onChange: setTClass
                }}
                placeholder="בחר מספר כיתה"
            />
            <SmallSpace />
            <AutoComplete
                name="role"
                options={semesterAndYearOptions}
                hideClear
                placeholder="שנת לימודים"
                input={{
                    value: schoolYear,
                    onChange: setSchoolYear
                }}
                labelKey="label"
            />
        </Alert>
    )
}

export default AddSchoolClass